var exports = {
  "c": "LabelWrapper__3ZP3j9",
  "J": "Label__7uewZ-",
};

module.exports = exports;
